import {Card, CardActionArea, Stack, styled} from '@mui/material';
import {IconIllustration} from 'presentation/components/IconIllustration';

const StyledCardActionArea = styled(CardActionArea)`
	border-radius: 8px;
`;

const StyledCard = styled(Card)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;
	border: none;
`;

const StyledStack = styled(Stack)`
	flex-direction: row;
	align-items: center;
	gap: 16px;
`;

const StyledIconButtonContainer = styled('div')`
	display: flex;
	align-items: center;
	color: ${({theme}) => theme.palette.primary.main};
`;

const StyledIconIllustration = styled(IconIllustration)`
	background-color: ${({theme}) => theme.palette.other.inversedColorIconBg};
`;

export {
	StyledCard,
	StyledCardActionArea,
	StyledStack,
	StyledIconButtonContainer,
	StyledIconIllustration,
};
